var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.fixed ? 'chapter-navigation-fixed' : 'chapter-navigation'},[(_vm.prev !== null)?_c('router-link',{staticClass:"chapter-navigation-prev",attrs:{"to":{
      name: _vm.route,
      params: { id: _vm.prev },
      query: Object.assign({}, this.$route.query, {position: undefined})
    },"title":"Previous chapter"}},[_c('ChevronLeftIcon',{attrs:{"width":_vm.fixed ? 48 : 24,"height":_vm.fixed ? 48 : 24}}),(!_vm.fixed)?[_vm._v("Previous")]:_vm._e()],2):_vm._e(),(_vm.next !== null)?_c('router-link',{staticClass:"chapter-navigation-next",attrs:{"to":{
      name: _vm.route,
      params: { id: _vm.next },
      query: Object.assign({}, this.$route.query, {position: undefined})
    },"title":"Next chapter"}},[(!_vm.fixed)?[_vm._v("Next")]:_vm._e(),_c('ChevronRightIcon',{attrs:{"width":_vm.fixed ? 48 : 24,"height":_vm.fixed ? 48 : 24}})],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }